import React from 'react'
import MasterLayout from 'views/MasterLayout'
import ClientsRouter from './Router'

export default function ClientsLayout(props) {
  return (
    <MasterLayout>
      <ClientsRouter match={props.match}/>
    </MasterLayout>
  )
}
